import gql from 'graphql-tag'

export default gql(`
	mutation updateVirtualCardConfig($fields: VirtualCardConfigFields) {
    cashAssist {
        updateVirtualCardConfig(fields: $fields) {
        	isActive
          classSuffix

          issuerName
          issuerEmail
          programName

          accountIdLabel
          rewardsTierLabel
          rewardsTier
          secondaryRewardsTierLabel
          secondaryRewardsTier

          logoImg
          wideLogoImg
          wideLogoGoogleImg
          heroGoogleImg

          backgroundColor
          foregroundColor
          labelColor
          
          homepageUri {
            description
            link
          }
          linkPhoneUri {
            description
            link
          }

          isDefault
        }
    }
}
`)
